var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"group"},[_c('div',{staticClass:"sentence-con",style:({
        top: `${_vm.offsetTop}px`,
      })},_vm._l((_vm.sentenceDataArr),function(sentence,index){return _c('div',{key:'list' + index,staticClass:"sentence-list"},_vm._l((sentence),function(word,idx){return _c('div',{key:'word' + idx,staticClass:"sentence",class:{
            'is-active': word.status == 'active',
            'is-right': word.status == 'right',
            'is-normal': word.status == 'normal',
            'is-active-wrong': word.status == 'active-wrong',
            'is-wrong': word.status == 'wrong',
            'is-space': word.word == ' ',
          }},[_c('div',[_vm._v(_vm._s(word.word))])])}),0)}),0)]),(_vm.showDialog)?_c('successDialog',{attrs:{"is-confirm-dialog":true,"dialog-title":'Congratulations',"dialog-img":_vm.dialogImg},on:{"clickConfirm":_vm.clickConfirm,"clickClose":_vm.clickClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }